// @flow

import React from "react";

import Section from "../../components/Section";
import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";

import { REMARK } from "./formFields";

type OkpRemarksInfoProps = {
  initialValues: {
    [REMARK]: boolean
  }
};

const OkpRemarksInfo = ({ initialValues }: OkpRemarksInfoProps) => (
  <Section title="Anmerkungen" reducedMargin>
    <EditableForm initialValues={initialValues} isLocked>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: REMARK,
            caption: () => "Anmerkungen"
          }}
        />
      </FormRow>
    </EditableForm>
  </Section>
);

export default OkpRemarksInfo;
